import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import './Dashboard.css';
import MiEmpresa from './sections/MiEmpresa';
import MisProductos from './sections/MisProductos';
import MiPlan from './sections/MiPlan';
import MisEstadisticas from './sections/MisEstadisticas';

type DashboardSection = 'mi-empresa' | 'mis-productos' | 'mi-plan' | 'mis-estadisticas' | 'mi-perfil';

const Dashboard: React.FC = () => {
  const [activeSection, setActiveSection] = useState<DashboardSection>('mi-empresa');
  const { user, isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  // Redirigir si no está autenticado
  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, isLoading, navigate]);

  const menuItems = [
    {
      id: 'mi-empresa' as DashboardSection,
      label: 'Mi Empresa',
      icon: 'fas fa-building',
      description: 'Gestiona los datos de tu empresa'
    },
    {
      id: 'mis-productos' as DashboardSection,
      label: 'Mis Productos',
      icon: 'fas fa-box',
      description: 'Administra tu catálogo de productos'
    },
    {
      id: 'mi-plan' as DashboardSection,
      label: 'Mi Plan',
      icon: 'fas fa-crown',
      description: 'Revisa tu plan actual y opciones'
    },
    {
      id: 'mis-estadisticas' as DashboardSection,
      label: 'Mis Estadísticas',
      icon: 'fas fa-chart-line',
      description: 'Analiza el rendimiento de tu negocio'
    }
  ];

  const renderSection = () => {
    console.log('Rendering section:', activeSection);
    switch (activeSection) {
      case 'mi-empresa':
        return <MiEmpresa />;
      case 'mis-productos':
        return <MisProductos />;
      case 'mi-plan':
        return <MiPlan />;
      case 'mis-estadisticas':
        return <MisEstadisticas />;
      default:
        return <MiEmpresa />;
    }
  };

  const handleSectionChange = (section: DashboardSection) => {
    console.log('Changing to section:', section);
    setActiveSection(section);
  };

  // Mostrar loading mientras se verifica la autenticación
  if (isLoading) {
    return (
      <div className="dashboard" style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div style={{ textAlign: 'center' }}>
          <div className="uk-margin-small-right" data-uk-spinner="ratio: 2"></div>
          <p>Cargando...</p>
        </div>
      </div>
    );
  }

  // No mostrar nada si no está autenticado (será redirigido)
  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className="dashboard">
     
     
      {/* Header */}
      <header className="dashboard-header">
     
     
        <div className="header-content">
          <h1>Panel de Control</h1>
          <div className="user-info">
            <span className="user-name">Bienvenido, {user?.nombreFantasia || 'Usuario'}</span>
            <div className="user-avatar">
              <i className="fas fa-building"></i>
            </div>
          </div>
        </div>
        
      </header>

      <div className="dashboard-container">
        {/* Sidebar */}
        <aside className="dashboard-sidebar">
          <nav className="sidebar-nav">
            {menuItems.map((item) => (
              <button
                key={item.id}
                className={`sidebar-item ${activeSection === item.id ? 'active' : ''}`}
                onClick={() => handleSectionChange(item.id)}
              >
                <div className="sidebar-item-icon">
                  <i className={item.icon}></i>
                </div>
                <div className="sidebar-item-content">
                  <span className="sidebar-item-label">{item.label}</span>
                  <span className="sidebar-item-description">{item.description}</span>
                </div>
              </button>
            ))}
          </nav>
        </aside>

        {/* Main Content */}
        <main className="dashboard-main">
          <div className="main-content">
            {renderSection()}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
